import angular from "angular";
import uiRouter from "angular-ui-router";
import signupComponent from "./scenes/signup/signup.component";
import companySignupComponent from "./scenes/company-signup/company-signup.component";
import companyOnboardingComponent from "./scenes/company-onboarding/company-onboarding.component";
import jobblerSignupComponent from "./scenes/jobbler-signup/jobbler-signup.component";
import SignupValidate from "./services/signup.validate";
import SignupRouting from "./services/routing";
import SignupFormatting from "./services/format";
import SignupTracking from "./services/tracking";
import SignupRegister from "./services/register";
import SignupCommon from "./services/common";

let signupModule = angular
  .module("signup", [uiRouter, "cleave.js"])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider
      .state("signup", {
        url: "/signup",
        template: "<signup></signup>",
        title: "Sign up",
      })
      .state("signup-company", {
        url: "/signup/company",
        title: "Sign up Company",
        params: {
          job_posting_type: null,
          job_title: null,
          jobble_type: null,
          pay_rate: null,
          pay_rate_jblr: null,
          dress_code: null,
          job_description: null,
          hourly_rate: null,
          preserve: null,
          t: null,
          isOnsiteManager: null,
          date_time: null,
          instructions: null,
          location: null,
          street_line_1: null,
        },

        template: "<company-signup></company-signup>",
      })
      .state("signup-onboarding", {
        url: "/company/onboarding",
        title: "Company Onboarding",
        params: {
          job_posting_type: null,
          job_title: null,
          jobble_type: null,
          pay_rate: null,
          pay_rate_jblr: null,
          dress_code: null,
          job_description: null,
          hourly_rate: null,
          preserve: null,
          t: null,
          date_time: null,
          instructions: null,
          location: null,
          street_line_1: null,
        },

        template: "<company-onboarding></company-onboarding>",
      })
      .state("company-onboarding-1", {
        url: "/company/onboarding/1",
        title: "Company Onboarding - Step 1",
        params: {},
        template: "<company-onboarding></company-onboarding>",
      })
      .state("company-onboarding-2", {
        url: "/company/onboarding/2?manager",
        title: "Company Onboarding - Step 2",
        params: {
          isOnsiteManager: null,
        },
        template: "<company-onboarding></company-onboarding>",
      })
      .state("company-onboarding-3", {
        url: "/company/onboarding/3",
        title: "Company Onboarding - Step 3",
        params: {},
        template: "<company-onboarding></company-onboarding>",
      })
      .state("company-onboarding-4", {
        url: "/company/onboarding/4",
        title: "Company Onboarding - Step 4",
        params: {},
        template: "<company-onboarding></company-onboarding>",
      })
      .state("signup-jobbler", {
        url: "/signup/jobbler",
        template: "<jobbler-signup></jobbler-signup>",
        title: "Sign up Jobbler",
      });
  })

  .service("signup.validator", SignupValidate)
  .service("signup.routing", SignupRouting)
  .service("signup.formatting", SignupFormatting)
  .service("signup.tracking", SignupTracking)
  .service("signup.register", SignupRegister)
  .service("signup.common", SignupCommon)

  .component("signup", signupComponent)
  .component("companySignup", companySignupComponent)
  .component("companyOnboarding", companyOnboardingComponent)
  .component("jobblerSignup", jobblerSignupComponent);

export default signupModule;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/signup.js